function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.60312035
}, React.createElement("g", {
  id: "4.4c\\u2013-User-\\u2013-Library-\\u2013-Default-Overlay-option-2-Copy",
  transform: "translate(-847.000000, -639.000000)",
  fill: "#000000",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Group-5",
  transform: "translate(117.000000, 136.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(28.000000, 38.000000)"
}, React.createElement("g", {
  id: "Image-Badge",
  transform: "translate(690.000000, 453.000000)"
}, React.createElement("g", {
  id: "noun_Image_574072-Copy-11",
  transform: "translate(12.000000, 12.000000)"
}, React.createElement("g", {
  id: "Group"
}, React.createElement("path", {
  d: "M5.339,7.4972 C6.4244,7.4972 7.3042,6.6174 7.3042,5.532 C7.3042,4.4466 6.4244,3.5668 5.339,3.5668 C4.2536,3.5668 3.3738,4.4466 3.3738,5.532 C3.3738,6.6174 4.2536,7.4972 5.339,7.4972 L5.339,7.4972 Z M14.4042,9.1752 L12.482,10.9046 C11.7416,11.5622 10.5994,11.4558 9.9932,10.6728 L9.566,10.1212 C9.0376,9.4386 8.0978,9.2688 7.3712,9.6816 C7.2922,9.7264 7.215,9.7762 7.1418,9.835 L2.8664,13.3256 C2.4992,13.6254 2.2862,14.0742 2.2862,14.5482 L2.2862,15.1738 C2.2862,15.464 2.5214,15.6992 2.8114,15.6992 L15.2506,15.6992 C15.5066,15.6992 15.714,15.4916 15.714,15.2358 L15.714,9.7586 C15.714,9.482 15.5794,9.26 15.387,9.123 C15.107,8.9236 14.7036,8.906 14.4042,9.1752 Z M16.8,16.0368 C16.8,16.4576 16.4578,16.8 16.037,16.8 L1.9632,16.8 C1.5424,16.8 1.2,16.4576 1.2,16.0368 L1.2,1.963 C1.2,1.5422 1.5424,1.2 1.9632,1.2 L16.037,1.2 C16.4578,1.2 16.8,1.5422 16.8,1.963 L16.8,16.0368 Z M1.9632,0 C0.879,0 0,0.8788 0,1.963 L0,16.0368 C0,17.121 0.879,18 1.9632,18 L16.037,18 C17.1212,18 18,17.121 18,16.0368 L18,1.963 C18,0.8788 17.1212,0 16.037,0 L1.9632,0 Z",
  id: "Shape"
}))))))));

const SvgImageBadge = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgImageBadge, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/image_badge.f5562442.svg";
export { ForwardRef as ReactComponent };